import { render, staticRenderFns } from "./order-kit-list.vue?vue&type=template&id=631aa98e&scoped=true&"
import script from "./order-kit-list.vue?vue&type=script&lang=js&"
export * from "./order-kit-list.vue?vue&type=script&lang=js&"
import style0 from "./order-kit-list.vue?vue&type=style&index=0&id=631aa98e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631aa98e",
  null
  
)

export default component.exports